import { render, staticRenderFns } from "./priceSetting.vue?vue&type=template&id=29fd77b7&scoped=true&"
import script from "./priceSetting.vue?vue&type=script&lang=js&"
export * from "./priceSetting.vue?vue&type=script&lang=js&"
import style0 from "./priceSetting.vue?vue&type=style&index=0&id=29fd77b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fd77b7",
  null
  
)

export default component.exports